module.exports = __webpack_public_path__ + "img/waves.350e8669.png";